import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import * as uuid from 'uuid'
@Component({
  selector: 'app-multi-select-with-input-options',
  templateUrl: './multi-select-with-input-options.component.html',
  styleUrls: ['./multi-select-with-input-options.component.scss']
})
export class MultiSelectWithInputOptionsComponent {

  ContainerId = uuid.v4()

  @Input() IconUrl: string = "/assets/icons/credit-card.svg"
  @Input() PlaceholderFilter: string = "Matricula"
  @Input() PlaceholderInput: string = "Buscar matricula"
  @Input() NoOptionsText: string = "Ninguna matricula introducida"
  @Input() SelectedText: string = "Matriculas"
  @Input() SelectedOptions: string[] = []
  @Input() Options: string[] = []

  @Output() filterValueEmitter = new EventEmitter<string[]>()

  FilterOpen: boolean = false;
  FilterInput: string = "";
  FocusInput: boolean = false;

  openFilter() {
    this.FilterOpen = !this.FilterOpen;
  }

  deleteFilter(event: Event) {
    event.stopPropagation();
    this.SelectedOptions = []
    this.FilterOpen = false;
    this.emitFilterValue();
  }


  emitFilterValue() {
    this.filterValueEmitter.emit(this.SelectedOptions);
  }

  addOptionSelected(event: Event) {
    event.stopPropagation();
    if (!this.Options.includes(this.FilterInput) && this.FilterInput?.trim() !== '') {
      this.SelectedOptions.push(this.FilterInput)
      this.Options.push(this.FilterInput)
      this.FilterInput = "";
      this.emitFilterValue()
    }
  }

  updateSelectedOption(option: string) {
    if (this.SelectedOptions.includes(option)) {
      this.SelectedOptions = this.SelectedOptions.filter((x: string) => { return x !== option })
    } else {
      this.SelectedOptions.push(option);
    }
    this.emitFilterValue();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;
    const absoluteElement = document.getElementById(this.ContainerId);

    if (
      this.FilterOpen &&
      absoluteElement &&
      !absoluteElement.contains(targetElement)
    ) {
      this.FilterOpen = false;
    }
  }


}
